import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/user/userSlice';
import photoReducer from '../features/photo/photoSlice';
import profileReducer from '../features/profile/profileSlice';
import galleryReducer from '../features/gallery/gallerySlice';
import individualRatingReducer from '../features/individualRating/individualRatingSlice';
import viewPhotoReducer from '../features/photo/viewPhotoSlice';
import notificationReducer from '../features/notification/notificationSlice';
import adminReducer from '../features/admin/adminSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    photo: photoReducer,
    profile: profileReducer,
    gallery: galleryReducer,
    individualRating: individualRatingReducer, 
    viewPhoto: viewPhotoReducer,
    notification: notificationReducer,
    admin: adminReducer,
  },
});
